// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChannelSelectionMenu_wrapper__tELyQ","button":"ChannelSelectionMenu_button__0IvvQ","chevronDownIcon":"ChannelSelectionMenu_chevronDownIcon__g7iy7"};